import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getFoodCategoriesRequestError, getFoodCategoriesRequestSuccess } from "../../slices/Content/GetFoodCategoriesSlice";
//import { getCategoriesRequest, getCategoriesRequestError, getCategoriesRequestSuccess } from "../../slices/Content/GetCategoriesSlice";

export const GetFoodCategoriesApi = (page, limit, status, search) => async (dispatch) => {
    const queryParams = new URLSearchParams({
        page: page,
        limit: limit,
        status: status,
        search: search
    }).toString();

    const urlWithParams = `${endpoints.getContentFoodCategories}?${queryParams}`;

    try {
        dispatch(getFoodCategoriesRequestError());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getFoodCategoriesRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getFoodCategoriesRequestError(_error));
            });
    } catch (error) { }
};
